import {Button as BootstrapButton, Spinner} from "react-bootstrap";

export const Button = (props) => {
    return (
        <BootstrapButton
            className={`${props.className ? ` ${props.className}` : ""}`}
            variant={props.variant}
            role={props.role ? props.role : ""}
            type={props.type && props.type}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            {props?.loading && <Spinner className="me-2" animation="border" size="sm" />}
            {props.children}
        </BootstrapButton>
    );
};
